import { useQuery } from '@apollo/client';
import { SpinnerMask } from '@atlassian/amkt-common';
import { useParams } from '@atlassian/mpac-ui';
import invariant from 'invariant';
import * as React from 'react';

import NotFound from '../../../../../../../common/components/NotFound';
import SEOFriendlyRedirect from '../../../../../../../common/components/SEOFriendlyRedirect';
import { APP_LISTING_HOME_LINK } from '../../constants';
import { getRouteToRedirectTo } from './utils';

import { GetMarketplaceAppByAppKey } from './queries.graphql';

const PluginsRedirectRoute = () => {
  const params = useParams();
  const { appKey } = params;
  invariant(appKey, `Parameter 'appKey' is required`);

  /* TODO: handle error case */
  const { loading, data } = useQuery(GetMarketplaceAppByAppKey, { variables: { appKey } });

  if (loading) {
    return <SpinnerMask active delay={750} testId="plugin-redirect" />;
  }

  if (data?.marketplaceAppByKey?.appId) {
    const redirectRoute = getRouteToRedirectTo({ app: data.marketplaceAppByKey, params });
    return <SEOFriendlyRedirect to={redirectRoute} statusCode={301} />;
  }

  return <NotFound homeLink={APP_LISTING_HOME_LINK} />;
};

export default PluginsRedirectRoute;
